/** @jsxImportSource @emotion/react */
import { Modal } from "antd";
import { icons } from "assets/mobile";
import moment from "moment";
import { AnnouncementItemType } from "types/announcement";

import { ModalDetailStyle } from "./index.style";

type Props = {
  item: AnnouncementItemType | null;
  onClose: () => void;
};

function ModalDetail({ item, onClose }: Props) {
  return (
    <Modal
      open={!!item}
      centered
      footer={<></>}
      focusTriggerAfterClose={false}
      forceRender
      closable={false}
      css={ModalDetailStyle.modalStyle}
      onCancel={onClose}
    >
      <div css={ModalDetailStyle.content}>
        <div css={ModalDetailStyle.header}>
          <span onClick={onClose} className="icon-back">
            <icons.ArrowRightIcon />
          </span>
          <span className="title">{item?.title}</span>
        </div>
        <div css={ModalDetailStyle.value}>
          <p className="date">
            {moment(item?.start).format("DD/MM/YYYY")} -{" "}
            {moment(item?.end).format("DD/MM/YYYY")}
          </p>
          <p className="content">{item?.content}</p>
        </div>
      </div>
    </Modal>
  );
}

export default ModalDetail;
